export function resolveSinglePrimaryTrial(session) {
  const trials = session?.presentedTrials || [];
  const trial = trials.find(item => item.status !== "completed") || trials[0];
  if (!trial || trial.stimuli?.length !== 1 || trial.stimuli[0]?.role !== "primary") {
    throw new Error("The activity requires exactly one primary stimulus");
  }
  return trial;
}
